module.exports = __webpack_public_path__ + "img/icon-headerjiqiren.ffc1f09f.png";